<app-elevation-section [title]="languageService.LNG('Label.Equipment')" [removeMargin]="allowEdit" [removePadding]="true">
  <dx-data-grid #datagriddx
    class="pointer"
    [dataSource]="transportEquipments"
    [rowAlternationEnabled]="true"
    [showBorders]="true"
    [columnAutoWidth]="true"
    (onEditorPreparing)="onEditorPreparing($event)"
    (onEditingStart)="onEditingStart($event)"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowInserting)="onRowInserting($event)"
    (onRowUpdating)="onRowUpdating($event)"    
    (onToolbarPreparing)="onToolbarPreparing($event)"
    height="{{ allowEdit ? 185 : 140 }}">

    <dxo-editing
      mode="batch"
      [allowUpdating]="allowEdit"
      [allowAdding]="allowEdit"
      [useIcons]="true">
    </dxo-editing>

    <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-selection mode="multiple" showCheckBoxesMode="always"> </dxo-selection>

    <dxi-column dataField="EquipmentId" [caption]="languageService.LNG('Label.Equipment')">
      <dxo-lookup [dataSource]="{ store: equipments, paginate: true, pageSize: 10 }" valueExpr="EquipmentId" displayExpr="DisplayName"></dxo-lookup>
    </dxi-column>

    <dxi-column [visible]="selectedTimeRecord?.IsTransport" dataField="TotSecondsToHH" [caption]="languageService.LNG('Label.Hours')" [width]="65" alignment="right">
      <dxi-validation-rule type="range" min="0" [message]="languageService.LNG('Label.Cannot.Enter.More.Than.23.Hours')"></dxi-validation-rule>
    </dxi-column>

    <dxi-column [visible]="selectedTimeRecord?.IsTransport" dataField="TotSecondsTomm" [caption]="languageService.LNG('Label.Minutes')" [width]="80" alignment="left">
      <dxi-validation-rule type="range" min="0" max="59" [message]="languageService.LNG('Label.Cannot.Enter.More.Than.59.Minutes')"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="IsMainEquipment" [caption]="languageService.LNG('Label.Main.Equipment')" dataType="boolean" [width]="100"></dxi-column>
    <dxi-column dataField="LoadedEquipment" [caption]="languageService.LNG('Label.Loaded.Equipment')" dataType="boolean" [width]="100"></dxi-column>

  </dx-data-grid>
</app-elevation-section>